// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__dkTMR","ranges":"BmiRanges_ranges__fhpHz"};